import React from 'react';
import Footer from '../containers/Footer/Footer';
import Contact from '../containers/Contact/Contact';
import Idro from '../containers/Idroflog/Idroflog';
import IdrAccordion from '../components/IdrAccordion';

const Idroflog = () => {
  return (
    <>
      <div className="product-page">
        <Idro />
        <IdrAccordion />
      </div>
      <Contact />
      <Footer />
    </>
  );
};

export default Idroflog;
